import { HttpClient } from 'common/HttpClient'
import { isTrastiBroker } from 'common/helpers/helpers'
import { Environment } from 'enviroment/AppSettings'
import { IGetMobywatelQRCodeReturnProps, IGetMobywatelQRCodeDTO } from './MObywatelServiceProps'

//#region SettingService Instance
let instance: MObywatelService
//#endregion


class MObywatelService {
   private readonly _client : HttpClient
   private readonly _mobywatelIdentificationQRCodePath = '/mobQrCode/identificationFullData'
   private readonly _mobywatelVerificationQRCodePath = '/mobQrCode/verificationData'
   private readonly _mobywatelVerificationFullQRCodePath = '/mobQrCode/verificationFullData'

   constructor(){
      if (instance) { //SINGLETON DESIGN PATTERN
         throw new Error("New instance cannot be created!!");
      }
   
      instance = this;
      this._client = new HttpClient(Environment.apiUrl);
   }

   private async _getMobywatelIdentificationCode(): Promise<IGetMobywatelQRCodeReturnProps> {
      return (await this._client.post<IGetMobywatelQRCodeReturnProps, IGetMobywatelQRCodeDTO>(
         this._mobywatelIdentificationQRCodePath,
         {},
         true
      )).data
   }

   private async _getMobywatelVerificationCode(): Promise<IGetMobywatelQRCodeReturnProps> {
      return (await this._client.post<IGetMobywatelQRCodeReturnProps, IGetMobywatelQRCodeDTO>(
         this._mobywatelVerificationQRCodePath,
         {},
         true
      )).data
   }

   private async _getMobywatelVerificationFullCode(): Promise<IGetMobywatelQRCodeReturnProps> {
      return (await this._client.post<IGetMobywatelQRCodeReturnProps, IGetMobywatelQRCodeDTO>(
         this._mobywatelVerificationFullQRCodePath,
         {},
         true
      )).data
   }

   public async getMobywatelQRCode(isIdentityPage: boolean): Promise<IGetMobywatelQRCodeReturnProps> {
      if(isIdentityPage) {
         return await this._getMobywatelIdentificationCode()
      }
      else {
        if (isTrastiBroker()) {
          return await this._getMobywatelVerificationFullCode()
        } else {
          return await this._getMobywatelVerificationCode()
        }
      }
   }
}


let mObywatelService = Object.freeze(new MObywatelService())//SINGLETON DESIGN PATTERN
export default mObywatelService;